import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
import { showNestedModal } from "../../features/modal/modalSlice";
import {
  setIsLocationInsidePolygon,
  updateAddressData,
} from "../../features/registeredAddress/registeredAddressSlice";
import PolygonEditorMap from "./maps/PolygonEditorMap";
import Btn from "../shared/button/Btn";
import getDeepEqual from "../../helper/getDeepEqual";

const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 27;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.6);

  .modal {
    min-width: min(820px, 100%);
    padding: 20px;
    border-radius: 10px;
    color: ${({ theme }) => theme.mainTextColor};
    background: ${({ theme }) => theme.mainBgColor};
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .modal-header,
  .bottom-container,
  .btn-side {
    display: flex;
    align-items: center;
  }

  .modal-header,
  .bottom-container {
    justify-content: space-between;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
  }

  .selected-address {
    font-size: 13px;
    font-weight: 600;
  }

  .content {
    position: relative;
    width: min(900px, calc(100vw - 72px));
    height: min(550px, 65vh);
    overflow: hidden;
    border-radius: 10px;
  }

  .desc-side p {
    color: var(--color-main);
    font-size: 14px;
    font-weight: 600;
  }

  .btn-side {
    justify-content: flex-end;
    gap: 8px;
  }

  @media (max-width: 850px) {
    padding: 0;

    .modal {
      width: 100vw;
      min-width: 100vw;
      min-height: 100dvh;
      border-radius: 0;
    }

    .content {
      width: 100%;
      height: 65vh;
    }

    .bottom-container {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;
    }
  }
`;

const KayitliAdresPolygonMapModal = () => {
  const dispatch = useDispatch();
  const { addressData, isLocationInsidePolygon } = useSelector(
    (state) => state.registeredAddress
  );
  const initialPaths = Array.isArray(addressData?.polygonCoords)
    ? addressData.polygonCoords
    : [];
  const [paths, setPaths] = useState(initialPaths);
  const [draftInside, setDraftInside] = useState(isLocationInsidePolygon);
  const [drawingMode, setDrawingMode] = useState(null);

  const normalizedPaths = paths.map((point) => ({
    lat: Number(point.lat),
    lng: Number(point.lng),
  }));
  const savedPaths = initialPaths.map((point) => ({
    lat: Number(point.lat),
    lng: Number(point.lng),
  }));
  const hasChanges = !getDeepEqual(normalizedPaths, savedPaths);

  const handleSubmit = () => {
    const polygonCoords = normalizedPaths.map((point, index) => ({
      ...point,
      sortOrder: index,
    }));
    dispatch(updateAddressData({ polygonCoords }));
    dispatch(setIsLocationInsidePolygon(draftInside));
    dispatch(showNestedModal(null));
  };

  const addressLabel =
    addressData?.locationData?.googleAddress ||
    addressData?.address ||
    addressData?.locationData?.location;

  return (
    <Container onClick={() => dispatch(showNestedModal(null))}>
      <div
        className="modal"
        onClick={(event) => {
          event.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="modal-header">
          <div className="title">Poligon Oluştur</div>
          {(drawingMode || paths.length >= 3) && (
            <p className="selected-address">Seçilen Adres: {addressLabel}</p>
          )}
        </div>

        <div className="content">
          {addressData?.locationData?.lat && addressData?.locationData?.lng && (
            <PolygonEditorMap
              maxVertices={15}
              paths={paths}
              setPaths={setPaths}
              tempIsInside={draftInside}
              onInsideChange={setDraftInside}
              drawingMode={drawingMode}
              setDrawingMode={setDrawingMode}
              center={{
                lat: Number(addressData.locationData.lat),
                lng: Number(addressData.locationData.lng),
              }}
              addressData={addressLabel}
            />
          )}
        </div>

        <div className="bottom-container">
          <div className="desc-side">
            {!draftInside && (drawingMode || paths.length >= 3) && (
              <p>Seçilen konum oluşturulan poligonun içerisinde olmalıdır.</p>
            )}
          </div>
          <div className="btn-side">
            {hasChanges ? (
              <Btn
                width="160px"
                color="#fff"
                bgColor={paths.length >= 3 && draftInside ? "#E85446" : "#7c7b7b"}
                isDisabled={paths.length < 3 || !draftInside}
                handleClick={handleSubmit}
                borderColor="none"
              >
                Bu Poligonu Kaydet
              </Btn>
            ) : (
              <span style={{ height: 40, display: "flex", alignItems: "center", fontSize: 14, fontWeight: 600, marginRight: 10 }}>
                Poligonda değişiklik yok
              </span>
            )}
            <Btn
              width="120px"
              color="#E85446"
              bgColor="#fff"
              handleClick={() => dispatch(showNestedModal(null))}
              borderColor="none"
            >
              Vazgeç
            </Btn>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KayitliAdresPolygonMapModal;
